(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-oddit-bundle-builder]';

  /* ----------------------------- money ----------------------------------- */
  function formatMoney(cents, format) {
    cents = Math.round(cents);
    var fmt = format || '${{amount}}';
    function withCommas(n) {
      return n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
    function build(precision, thousands, decimal) {
      var num = (cents / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = withCommas(parts[0]).replace(/,/g, thousands || ',');
      return parts[1] ? dollars + (decimal || '.') + parts[1] : dollars;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, name) {
      switch (name) {
        case 'amount': return build(2, ',', '.');
        case 'amount_no_decimals': return build(0, ',', '.');
        case 'amount_with_comma_separator': return build(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return build(0, '.', ',');
        case 'amount_with_apostrophe_separator': return build(2, "'", '.');
        default: return build(2, ',', '.');
      }
    });
  }

  function safeParse(str, fallback) {
    try { return JSON.parse(str); } catch (e) { return fallback; }
  }

  function initSection(section) {
    if (!section || section.dataset.odditInit === 'true') return;
    section.dataset.odditInit = 'true';

    var config = safeParse(
      (section.querySelector('[data-bundle-config]') || {}).textContent || '{}',
      {}
    );
    var MONEY = config.moneyFormat || '${{amount}}';

    var panel = section.querySelector('[data-panel]');
    var packButtons = Array.prototype.slice.call(section.querySelectorAll('[data-pack]'));
    var optionEls = Array.prototype.slice.call(section.querySelectorAll('[data-purchase-option]'));
    var cadenceSelect = section.querySelector('[data-cadence-select]');
    var slotsEl = section.querySelector('[data-slots]');
    var hintEl = section.querySelector('[data-slots-hint]');
    var progressEl = section.querySelector('[data-flavor-progress]');
    var subtotalEl = section.querySelector('[data-subtotal]');
    var savingsRow = section.querySelector('[data-savings-row]');
    var savingsTag = section.querySelector('[data-savings-tag]');
    var subSavingsTag = section.querySelector('[data-sub-savings-tag]');
    var subPriceEl = section.querySelector('[data-sub-price]');
    var subCompareEl = section.querySelector('[data-sub-compare]');
    var oncePriceEl = section.querySelector('[data-once-price]');
    var atcBtn = section.querySelector('[data-add-bundle]');
    var atcLabel = section.querySelector('[data-atc-label]');
    var benefitEls = Array.prototype.slice.call(section.querySelectorAll('[data-benefit-text]'));
    // Capture the raw benefit copy (with any [savings] tokens) before the first render
    var benefitTemplates = benefitEls.map(function (el) { return el.textContent; });

    // Mobile tray bar + drawer
    var trayBar = section.querySelector('[data-tray]');
    var trayThumbsWrap = section.querySelector('[data-tray-thumbs-wrap]');
    var trayThumbsEl = section.querySelector('[data-tray-thumbs]');
    var trayTotalEl = section.querySelector('[data-tray-total]');
    var traySavingsEl = section.querySelector('[data-tray-savings]');
    var trayHintEl = section.querySelector('[data-tray-hint]');
    var trayOpenBtn = section.querySelector('[data-tray-open]');
    var backdrop = section.querySelector('[data-drawer-backdrop]');
    var drawerCloseBtns = Array.prototype.slice.call(section.querySelectorAll('[data-drawer-close]'));

    /* --------------------------- state ----------------------------------- */
    var state = {
      required: 0,
      packSavings: 0,
      packLabel: '',
      purchase: config.hasSubscription ? 'subscribe' : 'onetime',
      cadence: cadenceSelect ? cadenceSelect.value : '',
      picks: [] // [{ variantId, price, title, image, plans:[{id,name}] }]
    };

    /* ------------------------ product lookup ----------------------------- */
    function readProduct(card) {
      return {
        variantId: card.getAttribute('data-variant-id'),
        price: parseInt(card.getAttribute('data-price'), 10) || 0,
        title: card.getAttribute('data-title') || '',
        image: card.getAttribute('data-image') || '',
        available: card.getAttribute('data-available') === 'true',
        plans: safeParse(card.getAttribute('data-selling-plans'), []) || [],
        card: card
      };
    }

    /* ---------------------------- packs ---------------------------------- */
    function selectPack(btn) {
      packButtons.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('oddit-bundle-builder__pack--active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      state.required = parseInt(btn.getAttribute('data-flavor-count'), 10) || 0;
      state.packSavings = parseFloat(btn.getAttribute('data-savings')) || 0;
      var label = btn.querySelector('.oddit-bundle-builder__pack-label');
      state.packLabel = label ? label.textContent.trim() : btn.textContent.trim();
      // Trim any picks beyond the new capacity
      if (state.picks.length > state.required) {
        state.picks = state.picks.slice(0, state.required);
      }
      renderSlots();
      render();
    }

    packButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { selectPack(btn); });
    });

    /* ----------------------------- tabs ---------------------------------- */
    var tabButtons = Array.prototype.slice.call(section.querySelectorAll('[data-tab]'));
    var groupEls = Array.prototype.slice.call(section.querySelectorAll('[data-group]'));

    function selectTab(btn) {
      var target = btn.getAttribute('data-tab');
      tabButtons.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('oddit-bundle-builder__tab--active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      groupEls.forEach(function (group) {
        var show = target === 'all' || group.getAttribute('data-group') === target;
        group.hidden = !show;
      });
    }

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { selectTab(btn); });
    });

    /* --------------------------- flavors --------------------------------- */
    function addFlavor(product) {
      if (!state.required) return;
      if (state.picks.length >= state.required) return;
      if (!product.available) return;
      if (!config.allowDuplicates) {
        var exists = state.picks.some(function (p) { return p.variantId === product.variantId; });
        if (exists) return;
      }
      state.picks.push({
        variantId: product.variantId,
        price: product.price,
        title: product.title,
        image: product.image,
        plans: product.plans
      });
      renderSlots();
      render();
      // On mobile, adding the final flavor auto-opens the buy box drawer for review
      if (state.required > 0 && state.picks.length === state.required) {
        openDrawer();
      }
    }

    function removePick(index) {
      state.picks.splice(index, 1);
      renderSlots();
      render();
    }

    section.querySelectorAll('[data-product]').forEach(function (card) {
      var addBtn = card.querySelector('[data-add-flavor]');
      if (!addBtn) return;
      addBtn.addEventListener('click', function () {
        addFlavor(readProduct(card));
      });
    });

    /* --------------------- info popovers (i icons) ----------------------- */
    var openPopover = null;
    section.querySelectorAll('[data-info-toggle]').forEach(function (btn) {
      var pop = btn.parentElement.querySelector('.oddit-bundle-builder__card-info-popover');
      if (!pop) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !pop.hidden;
        if (openPopover && openPopover !== pop) {
          openPopover.hidden = true;
        }
        pop.hidden = isOpen;
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        openPopover = isOpen ? null : pop;
      });
    });
    document.addEventListener('click', function () {
      if (openPopover) { openPopover.hidden = true; openPopover = null; }
    });

    /* --------------------------- slots ----------------------------------- */
    function renderSlots() {
      if (!slotsEl) return;
      slotsEl.innerHTML = '';
      for (var i = 0; i < state.required; i++) {
        var slot = document.createElement('div');
        slot.className = 'oddit-bundle-builder__slot';
        var pick = state.picks[i];
        if (pick) {
          slot.classList.add('oddit-bundle-builder__slot--filled');
          slot.setAttribute('title', pick.title);
          if (pick.image) {
            var img = document.createElement('img');
            img.className = 'oddit-bundle-builder__slot-image';
            img.src = pick.image;
            img.alt = pick.title;
            img.loading = 'lazy';
            slot.appendChild(img);
          }
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'oddit-bundle-builder__slot-remove';
          rm.setAttribute('aria-label', 'Remove ' + pick.title);
          // Trash-can icon (matches the cart's remove icon, snippets/icon-remove.liquid)
          rm.innerHTML = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/></svg>';
          (function (idx) {
            rm.addEventListener('click', function (e) {
              e.stopPropagation();
              removePick(idx);
            });
          })(i);
          slot.appendChild(rm);
        } else {
          slot.classList.add('oddit-bundle-builder__slot--empty');
        }
        slotsEl.appendChild(slot);
      }
      renderTrayThumbs();
    }

    /* ----------------------- mobile tray thumbnails ---------------------- */
    function renderTrayThumbs() {
      if (!trayThumbsEl) return;
      trayThumbsEl.innerHTML = '';
      for (var i = 0; i < state.required; i++) {
        var thumb = document.createElement('div');
        thumb.className = 'oddit-bundle-builder__tray-thumb';
        var pick = state.picks[i];
        if (pick) {
          thumb.setAttribute('title', pick.title);
          if (pick.image) {
            var img = document.createElement('img');
            img.src = pick.image;
            img.alt = pick.title;
            img.loading = 'lazy';
            thumb.appendChild(img);
          }
        } else {
          thumb.className += ' oddit-bundle-builder__tray-thumb--empty';
          thumb.textContent = '+';
        }
        trayThumbsEl.appendChild(thumb);
      }
      // Toggle the fade/chevron cue only when the strip actually overflows
      if (trayThumbsWrap) {
        var scrollable = trayThumbsEl.scrollWidth > trayThumbsEl.clientWidth + 1;
        trayThumbsWrap.classList.toggle('oddit-bundle-builder__tray-thumbs-wrap--scrollable', scrollable);
      }
    }

    /* --------------------------- purchase -------------------------------- */
    function selectPurchase(mode) {
      state.purchase = mode;
      optionEls.forEach(function (el) {
        var on = el.getAttribute('data-purchase') === mode;
        el.classList.toggle('oddit-bundle-builder__option--active', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      render();
    }

    optionEls.forEach(function (el) {
      el.addEventListener('click', function () {
        selectPurchase(el.getAttribute('data-purchase'));
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectPurchase(el.getAttribute('data-purchase'));
        }
      });
    });

    if (cadenceSelect) {
      cadenceSelect.addEventListener('change', function () {
        state.cadence = cadenceSelect.value;
        // Choosing a cadence implies the subscribe option
        selectPurchase('subscribe');
      });
      cadenceSelect.addEventListener('click', function (e) { e.stopPropagation(); });
    }

    /* ---------------------------- render --------------------------------- */
    function render() {
      var count = state.picks.length;
      var remaining = Math.max(state.required - count, 0);

      if (progressEl) progressEl.textContent = '(' + count + '/' + state.required + ')';

      if (hintEl) {
        if (state.required > 0 && remaining === 0) {
          hintEl.textContent = config.slotReadyText || 'Your bundle is ready!';
          hintEl.classList.add('oddit-bundle-builder__slots-hint--ready');
        } else {
          var tmpl = config.slotHint || 'Choose [count] more flavors to proceed.';
          hintEl.innerHTML = tmpl.replace('[count]', '<strong>' + remaining + '</strong>');
          hintEl.classList.remove('oddit-bundle-builder__slots-hint--ready');
        }
      }

      // Money: the subscription savings tracks the selected pack size's percentage.
      // One-time is full price; subscribing applies the current pack's discount.
      var base = state.picks.reduce(function (sum, p) { return sum + p.price; }, 0);
      var savingsPct = state.packSavings || 0;
      var savePrefix = config.savePrefix || 'Save';
      // Pack discount applies to BOTH modes; subscribing stacks a further SUB_SAVINGS_PCT.
      var SUB_SAVINGS_PCT = 20;
      var onceTotal = base * (1 - savingsPct / 100);
      var subTotal = onceTotal * (1 - SUB_SAVINGS_PCT / 100);
      // The amount actually charged for the selected purchase mode — also shown
      // in the ATC button and as the Bundle Subtotal value.
      var payTotal = state.purchase === 'subscribe' ? subTotal : onceTotal;

      var complete = state.required > 0 && count === state.required;

      // Benefit copy: fill any [savings] token with the current pack's percentage.
      // The token renders as "N%" (an adjacent literal % is absorbed so we never
      // get "%%"), and a benefit that relies on the token is hidden when there's
      // no saving (so we never show "Get 0% OFF").
      if (benefitEls.length) {
        benefitEls.forEach(function (el, i) {
          var tmpl = benefitTemplates[i];
          if (tmpl.indexOf('[savings]') === -1) return;
          var li = el.closest ? el.closest('.oddit-bundle-builder__benefit') : el.parentElement;
          if (savingsPct > 0) {
            el.textContent = tmpl.replace(/\[savings\]\s*%?/g, savingsPct + '%');
            if (li) li.hidden = false;
          } else if (li) {
            li.hidden = true;
          }
        });
      }

      // Subscribe "Save X%" badge follows the pack size (hidden when there's no saving)
      if (subSavingsTag) {
        subSavingsTag.textContent = savePrefix + ' ' + SUB_SAVINGS_PCT + '%';
        subSavingsTag.hidden = false;
      }

      if (subtotalEl) subtotalEl.textContent = complete ? formatMoney(payTotal, MONEY) : '—';

      // Footer savings reflects the currently selected purchase mode
      var activeSavingsPct = state.purchase === 'subscribe' ? SUB_SAVINGS_PCT : savingsPct;
      if (savingsRow && savingsTag) {
        if (complete && activeSavingsPct > 0) {
          savingsTag.textContent = savePrefix + ' ' + activeSavingsPct + '%';
          savingsRow.hidden = false;
        } else {
          savingsRow.hidden = true;
        }
      }

      if (subPriceEl) subPriceEl.textContent = complete ? formatMoney(subTotal, MONEY) : '';
      if (subCompareEl) subCompareEl.textContent = complete ? formatMoney(onceTotal, MONEY) : '';
      if (oncePriceEl) oncePriceEl.textContent = complete ? formatMoney(onceTotal, MONEY) : '';

      if (atcBtn) {
        atcBtn.disabled = !complete;
        atcBtn.setAttribute('aria-disabled', complete ? 'false' : 'true');
      }
      if (atcLabel) {
        if (complete) {
          atcLabel.textContent = (config.atcLabel || 'Add to Cart') + ' • ' + formatMoney(payTotal, MONEY);
        } else {
          atcLabel.textContent = config.atcIncompleteLabel || 'Pick your flavors';
        }
      }

      // Mobile tray bar: running total, savings and hint (previews before complete)
      if (trayTotalEl) trayTotalEl.textContent = formatMoney(payTotal, MONEY);
      if (traySavingsEl) {
        var traySaved = base - payTotal;
        if (traySaved > 0) {
          traySavingsEl.textContent = savePrefix + ' ' + formatMoney(traySaved, MONEY);
          traySavingsEl.hidden = false;
        } else {
          traySavingsEl.textContent = '';
          traySavingsEl.hidden = true;
        }
      }
      if (trayHintEl) {
        var reviewCta = config.trayReviewText || 'Tap to review';
        if (state.required > 0 && remaining === 0) {
          trayHintEl.textContent = (config.slotReadyText || 'Your bundle is ready!') + ' · ' + reviewCta;
        } else {
          var trayTmpl = config.slotHint || 'Choose [count] more flavors to proceed.';
          trayHintEl.textContent = trayTmpl.replace('[count]', remaining) + ' · ' + reviewCta;
        }
      }
    }

    /* -------------------------- add to cart ------------------------------ */
    function planIdForPick(pick) {
      if (state.purchase !== 'subscribe' || !pick.plans || !pick.plans.length) return null;
      var match = pick.plans.filter(function (pl) { return pl.name === state.cadence; })[0];
      return (match || pick.plans[0]).id;
    }

    function buildItems() {
      var prefix = config.bundleIdPrefix || 'bundle';
      var bundleId = prefix + '-' + Date.now() + '-' + Math.floor(Math.random() * 1e4);
      var props = {};
      props['_' + prefix + '_id'] = bundleId;
      if (state.packLabel) props['_' + prefix + '_size'] = state.packLabel;

      // Merge identical (variant + plan) picks into one line with summed qty
      var map = {};
      var order = [];
      state.picks.forEach(function (pick) {
        var planId = planIdForPick(pick);
        var key = pick.variantId + ':' + (planId || '0');
        if (!map[key]) {
          map[key] = {
            id: pick.variantId,
            quantity: 0,
            selling_plan: planId ? Number(planId) : undefined,
            properties: props
          };
          order.push(key);
        }
        map[key].quantity += 1;
      });
      return order.map(function (k) { return map[k]; });
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;
        if (!(window.OdditCartDrawer && typeof window.OdditCartDrawer.addMultipleToCart === 'function')) {
          return;
        }
        var items = buildItems();
        if (!items.length) return;

        atcBtn.classList.add('is-loading');
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-busy', 'true');

        window.OdditCartDrawer.addMultipleToCart(items)
          .then(function () {
            if (typeof window.OdditCartDrawer.open === 'function') window.OdditCartDrawer.open();
            // Reset the builder after a successful add
            state.picks = [];
            renderSlots();
            render();
            closeDrawer();
          })
          .catch(function () {})
          .finally(function () {
            atcBtn.classList.remove('is-loading');
            atcBtn.removeAttribute('aria-busy');
            render();
          });
      });
    }

    /* -------------------- mobile tray + drawer --------------------------- */
    function isMobile() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    var mobileOnScreen = false;
    var drawerOpen = false;

    function syncMobile() {
      var mobile = isMobile();
      var showTray = mobile && mobileOnScreen && !drawerOpen;
      var showDrawer = mobile && drawerOpen;
      if (trayBar) trayBar.classList.toggle('oddit-bundle-builder__tray--visible', showTray);
      if (panel) panel.classList.toggle('oddit-bundle-builder__panel--open', showDrawer);
      if (backdrop) backdrop.classList.toggle('oddit-bundle-builder__backdrop--open', showDrawer);
      document.body.style.overflow = showDrawer ? 'hidden' : '';
    }

    function openDrawer() {
      if (!isMobile()) return;
      drawerOpen = true;
      syncMobile();
    }
    function closeDrawer() {
      drawerOpen = false;
      syncMobile();
    }

    // Tapping the tray (arrow, totals, or a thumbnail) opens the drawer. Horizontal
    // drags of the thumbnail strip scroll rather than click, so they don't trigger it.
    if (trayBar) trayBar.addEventListener('click', openDrawer);
    drawerCloseBtns.forEach(function (btn) { btn.addEventListener('click', closeDrawer); });
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerOpen) closeDrawer();
    });
    window.addEventListener('resize', function () {
      if (!isMobile()) drawerOpen = false;
      syncMobile();
    });

    // Show the tray only while the builder is on screen (mobile only)
    if (trayBar && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          mobileOnScreen = entry.isIntersecting;
          if (!entry.isIntersecting) drawerOpen = false;
          syncMobile();
        });
      }, { threshold: 0, rootMargin: '0px 0px -30% 0px' });
      observer.observe(section.querySelector('.oddit-bundle-builder__catalog') || section);
    } else {
      // No IntersectionObserver: keep the tray available whenever on mobile
      mobileOnScreen = true;
      syncMobile();
    }

    /* ---------------------------- boot ----------------------------------- */
    // Default pack: the pre-selected one, else the first
    var activePack = section.querySelector('.oddit-bundle-builder__pack--active') || packButtons[0];
    if (activePack) selectPack(activePack);
    else render();
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector
      ? e.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) initSection(section);
  });
})();